import { render, staticRenderFns } from "./TopVendors.vue?vue&type=template&id=51b71dd6&"
import script from "./TopVendors.vue?vue&type=script&lang=js&"
export * from "./TopVendors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports